import React from "react";
import useEnterpriseLogo from "../hooks/useEnterpriseLogo";
import VelaKodaMobile from "../assets/Images/MobileLogo.svg";

export default function AuthEnterpriseLogo({ alt = "Logo", className = "zerobox-logo" }) {
  const { logoSrc } = useEnterpriseLogo({ defaultLogoSrc: VelaKodaMobile });
  return <img className={className} src={logoSrc} alt={alt} />;
}

